<template>
    <b-row>
        <b-col md="12">
            <component-header
                title="Bulk Promotion"
                :isLoading="loading"
                :hasSearch="true"
                :hasReload="true"
                :hasRadio="true"
                @search-query="(val) => (filter = val)"
                @reload-data="refreshAllDataItem"
                @dateRangeEmit="dateRangeInput"
                @radioChangeInputEmit="dateRangeInput"
                :radioOptions="dayRadioOption"
                createButtonText="Create Bulk Promotion"
                @create-press="$router.push({ name: 'create-promo' })"
            />
        </b-col>
        <b-col md="12">
            <b-card class="card-wrap" border-variant="info">
                <div class="table-wrapper">
                    <b-table
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive="sm"
                        :items="criteriaList"
                        :fields="tenantColumns"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :filter="filter"
                        @filtered="onFilter"
                        thead-class="header"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                        stacked="md"
                        class="bulk-promotion-table tableRadius professional-stacked-table"
                    >
                        <template slot="cell(createdAt)" slot-scope="data">
                            <div>{{ data.item.createdAt | formatedate }}</div>
                        </template>
                        <template slot="cell(action)" slot-scope="data">
                            <div class="d-flex">
                                <ActionButtonGroup
                                    showView
                                    @view="viewCriteria(data.item)"
                                >
                                    <b-button
                                        :disabled="
                                            data.item.status == 'PENDING'
                                        "
                                        size="sm"
                                        class="mr-2 circularIcon"
                                        variant="primary"
                                        @click="downloadDetails(data.item)"
                                    >
                                        <i class="fa fa-download"></i>
                                    </b-button>
                                </ActionButtonGroup>

                                <!-- <div>
                  <b-button
                    v-if="$currentUserData.role == 'Tenant'"
                    size="sm"
                    class="mr-2 circularIcon"
                    variant="danger"
                    @click="deleteCriteria(data.item)"
                  >
                    <i class="fa fa-trash bin"></i>
                  </b-button>
                </div> -->
                            </div>
                        </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="filterCount"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import ebButton from "@/components/FormElements/Button";
import ComponentHeader from "@/components/componentNewHeader";
import { mapGetters } from "vuex";
import moment from "moment";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "BulkPromotion",
    components: {
        ebButton,
        ComponentHeader,
        ActionButtonGroup,
    },
    data() {
        return {
            dateFilter: 1,
            filterCount: 0,
            loading: false,
            perPage: 10,
            currentPage: 1,
            filter: "",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            fixed: false,
            dark: false,
            sortBy: "createdAt",
            sortDesc: true,
            tenantColumns: [
                {
                    key: "createdAt",
                    label: "Date",
                    sortable: true,
                    thStyle: { minWidth: "135px" },
                },
                {
                    key: "count",
                    label: "Impacted Customer",
                    sortable: true,
                    formatter: (value) =>
                        value === null || value === undefined ? 0 : value,
                    thStyle: { minWidth: "115px" },
                },
                {
                    key: "collectionName",
                    label: "Search Entity",
                    thStyle: { minWidth: "100px" },
                },
                {
                    key: "status",
                    label: "Criteria Status",
                    formatter: "criteriaStatus",
                    thStyle: { minWidth: "100px" },
                    tdClass: (value) => {
                        if (value === "COMPLETED") {
                            return "status-green";
                        } else {
                            return "status-orange";
                        }
                    },
                },
                {
                    key: "notificatonStatus",
                    label: "Template Status",
                    formatter: "criteriaStatus",
                    thStyle: { minWidth: "100px" },
                    tdClass: (value) => {
                        if (value === "COMPLETED") {
                            return "status-green";
                        } else {
                            return "status-orange";
                        }
                    },
                },
                {
                    key: "apporvalStatus",
                    label: "Approval Status",
                    formatter: "criteriaStatus",
                    thStyle: { minWidth: "100px" },
                    tdClass: (value) => {
                        if (value === "COMPLETED" || value === "APPROVED") {
                            return "status-green";
                        } else {
                            return "status-orange";
                        }
                    },
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: { minWidth: "90px" },
                },
            ],
            dayRadioOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 days",
                    value: 7,
                },
                {
                    text: "30 days",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            getFetchListOfCriteria: "bulkNotification/GetFetchListOfCriteria",
        }),
        criteriaList() {
            if (!this.getFetchListOfCriteria?.data) return [];
            let criteriaListItem = this.getFetchListOfCriteria.data.filter(
                (listItem) => {
                    return listItem.category == "PROMO";
                },
            );
            return criteriaListItem;
        },
    },
    methods: {
        dateRangeInput(e) {
            this.dateFilter = e;
            this.refreshAllDataItem();
        },
        getDateData(dateData) {
            if (dateData == 1) {
                const data = {
                    fromDate: moment().format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                return data;
            } else {
                const data = {
                    fromDate: moment()
                        .subtract(30, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
                if (typeof dateData === "number") {
                    data.fromDate = moment()
                        .subtract(dateData, "days")
                        .format("YYYY-MM-DD");
                    return data;
                } else if (typeof dateData === "object") {
                    return dateData;
                }
                return data;
            }
        },
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        criteriaStatus(value) {
            const capitalized =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            return capitalized;
        },
        downloadDetails(data) {
            if (data.status == "COMPLETED" && data.url) {
                window.location = data.url;
            } else {
                this.$swal({
                    title: "Error",
                    text: "Cannot download data. Please try again later.",
                    type: "error",
                });
            }
        },
        viewCriteria(data) {
            if (data.count == null) {
                this.$swal({
                    title: "No data found",
                    type: "error",
                });
                return;
            }
            this.$router.push({
                name: "bulkpromo",
                params: {
                    id: data._id,
                },
            });
        },

        //delete not required for now

        // deleteCriteria(data) {
        //   this.$swal({
        //     title: "Delete this Criteria?",
        //     text: "Are you sure? You want to Delete this Criteria?",
        //     type: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     confirmButtonText: "Yes, Delete it!",
        //   }).then((result) => {
        //     if (result.value) {
        //       let payload = { ids: [] };
        //       payload.ids.push(data._id);
        //       this.$store
        //         .dispatch("bulkNotification/deleteCriteria", payload)
        //         .then((result) => {
        //           this.$toasted.success("Criteria Deleted Successfully");
        //           this.refreshAllDataItem();
        //           this.loading = true;
        //         })
        //         .catch((err) => {
        //           // delete failed
        //         });
        //     }
        //   });
        // },

        refreshAllDataItem() {
            this.loading = true;
            let payload = {
                status: "",
                ...this.getDateData(this.dateFilter),
            };
            this.$store
                .dispatch("bulkNotification/fetchListOfCriteria", payload)
                .then((data) => {
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
    mounted() {
        this.refreshAllDataItem();
    },
    filters: {
        formatedate: function (value) {
            if (value) {
                return moment(String(value)).format("DD/MM/YYYY hh:mm A");
            }
        },
    },
};
</script>
<style scoped>
.status-orange {
    color: #ff9f47;
    font-weight: 600;
}

.status-green {
    color: #34a853;
    font-weight: 600;
}

.card-wrap {
    border-radius: 16px;
}

.table-wrapper {
    overflow-x: auto;
    width: 100%;
    -webkit-overflow-scrolling: touch;
}

.bulk-promotion-table {
    min-width: 740px;
    width: 100%;
}

.bulk-promotion-table >>> .b-table-busy-slot {
    min-width: 740px;
}

.pagination-wrapper {
    float: right;
    margin-top: 1rem;
}

.circularIcon {
    height: 36px;
    width: 36px;
    border-radius: 50%;
    padding: 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Match Today dropdown size with search and other header elements */
::v-deep .date-filter {
    min-width: 250px;
}

::v-deep .date-filter .vs__dropdown-toggle,
::v-deep .date-filter .vs__selected-options {
    min-width: 250px !important;
    height: 34.5px !important;
    min-height: 34.5px !important;
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        float: none;
        width: 100%;
        display: flex;
        justify-content: center;
        margin-top: 1rem;
    }

    .table-wrapper {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
    }

    .circularIcon {
        height: 32px;
        width: 32px;
    }
    ::v-deep .date-filter {
        position: relative;
    }

    ::v-deep .date-filter .vs__dropdown-toggle {
        width: 100%;
        padding-right: 2.5rem;
    }

    ::v-deep .date-filter .vs__open-indicator {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        margin: 0;
        pointer-events: none;
    }
}
</style>
